import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SowService {

  constructor(private http: HttpClient) {

  }

  /**
   *
   * @param param
   * @returns
   */
  getListResourceSow() {
    return this.http.get(`${environment.api_cm_sow}/listResourceSow`)
      .pipe(map(data => data));
  }

  /**
   *
   * @param poNumber
   * @returns
   */
  getListpoNumber(poNumber: number) {
    let params = new HttpParams();
    params = params.append('poNumber', poNumber);
    return this.http.get(`${environment.api_cm_sow}/listPoNumber`, { params: params })
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  saveSow(param: any) {
    return this.http.post(`${environment.api_cm_sow}/saveSow`, param )
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  getListSow(param: any) {
    let params = new HttpParams();
    if (param.filter != null && param.filter?.length > 0) {
      params = params.append('filter', param.filter);
    }
    params = params.append('page', param.pageIndex);
    params = params.append('page_size', param.pageSize);
    return this.http.get(`${environment.api_cm_sow}/listSow`, { params: params })
      .pipe(map(data => data));
  }

  downloadFile(id: number) {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.get(`${environment.api_cm_sow}/downloadFile`, { params: params } )
        .pipe(map(data => data));
  }

}
